import AppConfig from "@/_config/application-config"
import childRoutes from "@/apps/aspportal/routes/index.js"
import BrowserStorage from "@/_util/storage-modes.browser-storage";

const namespace = "aspportal"
const localStorage = new BrowserStorage(namespace);
const sessionStorage = new BrowserStorage(namespace, true);

const appConfig = {
  name: "ASP Portal",
  namespace,
  description: null,
  version: "0.1.0",
  icon: "mdi-alpha-r-circle-outline",
  parentRoute: "/aspportal",
  accentColor: "red",
  childRoutes,
  defaultRoute: "home",
  component: () => import( /* webpackChunkName: "home-parent" */ "@/apps/aspportal/Application.vue"),
  settings: {
    api_url: "https://api.nonprd.lyb.com/external/asppsc-stg/api/",
    client_id: "faa2ebf4-a872-43c3-a5d7-cf5dd3e0aa7c",  
    scope: "api://faa2ebf4-a872-43c3-a5d7-cf5dd3e0aa7c/Read.All",
    authorize_url:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
    token_url:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
    logout_url:
      "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=https://aspportal-web.azurewebsites.net/#/aspportal/logout",
    redirect_uri: window.location.origin, //Gets the current
    autologin: true,
    debug: false,
    currentTime: null,
    currentTimeInterval: null,
    navigations: [
      {
        icon: "mdi-home",
        text: "Home",
        link: "/aspportal/home",
      },
      {
        icon: "mdi-view-grid",
        text: "Program Overview ",
        link: "/aspportal/programoverview",
      },
      {
        icon: "mdi-floor-plan",
        text: "ASP Details",
        link: "/aspportal/aspdetails",
      },
  
      {
        icon: "mdi-application-cog",
        text: "Admin",
        link: "/aspportal/admin",
        items: [
          {
            icon: "mdi-account-multiple",
            text: "Users",
            link: "/aspportal/users",
          },
          {
            icon: "mdi-file-cog-outline",
            text: "Master Data",
            link: "/aspportal/masterdetails",
          },
        ],
        roles: ["ASPPortalAdmin"],
      }

    ],
  },
  store: {
    themeColor: {
      default: "red",
      storageMode: localStorage,
    },
    isTrue: {
      default: true,
      storageMode: sessionStorage,
    },
  }

}

export default AppConfig.merge(appConfig);

